(function () {
  const originalFetch = window.fetch;

  function getMinQtyByLine(line) {
    const item = document.querySelector(`[data-js-cart-item][data-line="${line}"]`);
    if (!item) return 1;

    const input = item.querySelector('input.qty');
    if (!input) return 1;

    return parseInt(input.dataset.minQty || input.getAttribute('min') || '1', 10) || 1;
  }

  window.fetch = function (url, options) {
    try {
      const urlString = typeof url === 'string' ? url : url.url || '';

      if (
        urlString.includes('/cart/change') &&
        options &&
        options.body
      ) {
        let body = JSON.parse(options.body);

        if (body.line && typeof body.quantity !== 'undefined') {
          const minQty = getMinQtyByLine(body.line);
          const qty = parseInt(body.quantity, 10);

          if (qty > 0 && qty < minQty) {
            body.quantity = minQty;
            options.body = JSON.stringify(body);

            const item = document.querySelector(`[data-js-cart-item][data-line="${body.line}"]`);
            const input = item ? item.querySelector('input.qty') : null;

            if (input) input.value = minQty;

            alert(`Die Mindestbestellmenge beträgt ${minQty} Stück.`);
          }
        }
      }
    } catch (e) {
      console.warn('Knopftruhe Mindestmenge konnte nicht geprüft werden:', e);
    }

    return originalFetch.apply(this, arguments);
  };
})();